import React from "react";
import {
  faArrowUpFromBracket,
  faLocationDot,
  faUsers,
  faFileLines,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../base";

const CreatePackNav = (props) => {
  const canClickLocation = props.editing ? true : false;
  const canClickUsers = true;
  const canClickForms = props.editing ? true : false;
  const canClickUploads = props.editing ? true : false;

  return (
    <div className="create-pack-nav--wrapper">
      {!props.editing && (
        <>
          <div className="create-pack-nav--item">
            <Button
              className="create-pack-nav--icon create-pack-nav--icon--active"
            >
              <FontAwesomeIcon icon={faLocationDot} />
            </Button>
            <div className="create-pack-nav--title">
              Location
            </div>
          </div>
          <div className="create-pack-nav--item">
            <Button
              className={"create-pack-nav--icon " + (props.sectionView === "users" ? "create-pack-nav--icon--active " : "") + (!canClickUsers && props.sectionView !== "users" ? "create-pack-nav--icon--disabled " : "")}
              onClick={canClickUsers ? props.handleCreatePack : undefined}
            >
              <FontAwesomeIcon icon={faUsers} />
            </Button>
            <div className="create-pack-nav--title">
              Users
            </div>
          </div>
          <div className="create-pack-nav--item">
            <Button
              className="create-pack-nav--icon create-pack-nav--icon--disabled"
            >
              <FontAwesomeIcon icon={faFileLines} />
            </Button>
            <div className="create-pack-nav--title">
              Forms
            </div>
          </div>
          <div className="create-pack-nav--item">
            <Button
              className="create-pack-nav--icon create-pack-nav--icon--disabled"
            >
              <FontAwesomeIcon icon={faArrowUpFromBracket} />
            </Button>
            <div className="create-pack-nav--title">
              Uploads
            </div>
          </div>
        </>
      )}
      {props.editing && (
        <>
          <div className="create-pack-nav--item">
            <Button
              className={"create-pack-nav--icon " + (props.sectionView === "location" ? "create-pack-nav--icon--active " : "") + (!canClickLocation && props.sectionView !== "location" ? "create-pack-nav--icon--disabled " : "")}
              onClick={canClickLocation ? () => props.handleEditPack(null, 'location') : undefined}
            >
              <FontAwesomeIcon icon={faLocationDot} />
            </Button>
            <div className="create-pack-nav--title">
              Location
            </div>
          </div>
          <div className="create-pack-nav--item">
            <Button
              className={"create-pack-nav--icon " + (props.sectionView === "users" ? "create-pack-nav--icon--active " : "") + (!canClickUsers && props.sectionView !== "users" ? "create-pack-nav--icon--disabled " : "")}
              onClick={canClickUsers ? () => props.handleEditPack(null, 'users') : undefined}
            >
              <FontAwesomeIcon icon={faUsers} />
            </Button>
            <div className="create-pack-nav--title">
              Users
            </div>
          </div>
          <div className="create-pack-nav--item">
            <Button
              className={"create-pack-nav--icon " + (props.sectionView === "forms" ? "create-pack-nav--icon--active " : "") + (!canClickForms && props.sectionView !== "forms" ? "create-pack-nav--icon--disabled " : "")}
              onClick={canClickForms ? () => props.handleEditPack(null, 'forms') : undefined}
            >
              <FontAwesomeIcon icon={faFileLines} />
            </Button>
            <div className="create-pack-nav--title">
              Forms
            </div>
          </div>
          <div className="create-pack-nav--item">
            <Button
              className={"create-pack-nav--icon " + (props.sectionView === "uploads" ? "create-pack-nav--icon--active " : "") + (!canClickUploads && props.sectionView !== "uploads" ? "create-pack-nav--icon--disabled " : "")}
              onClick={canClickUploads ? () => props.handleEditPack(null, 'uploads') : undefined}
            >
              <FontAwesomeIcon icon={faArrowUpFromBracket} />
            </Button>
            <div className="create-pack-nav--title">
              Uploads
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CreatePackNav;